/**
 * Created by razial on 26.10.2021
 */

const PocketBubble = function (unit) {
    this.code = unit.code;
    this.stage = unit.stage;
    this.x = unit.x;
    this.y = unit.y;

    this.onRemoved = function () {};
    this.onShowFinger = function () {};
    this.onGetView = function () {};
};

PocketBubble.prototype.remove = function () {
    Map2dLocation.currentLocation.pocket.removeBubble(this);
    this.onRemoved();
};

PocketBubble.prototype.setPosition = function (x, y) {
    this.x = Math.round(x);
    this.y = Math.round(y);
    Map2dLocation.currentLocation.pocket.save();
};

PocketBubble.prototype.spawn = function (node) {
    if (this.spawned) {
        return;
    }

    const remains = Map2dLocation.currentLocation.spawn({ code: this.code, stage: this.stage }, node, {
        fromNode: true,
        spawnSource: "pocket"
    });
    if (!remains.length) {
        this.spawned = true;
        this.remove();
    }
};

PocketBubble.prototype.showFinger = function () {
    this.onShowFinger();
};
